import { Group, Loader, Table as MantineTable, Pagination, ScrollArea, Text } from '@mantine/core';
import React, { useState } from 'react';
import { ActionsRender, ActionProps } from "./actions_render"

interface TableProps<T>{
    loading? : boolean;
    error? : string;
    data: T[];
    leftIcon?: any;
    columns: {key:string; title:any; style?: any; render?: (item:T) => any}[];
    actions?: ActionProps[];
    [key: string]: any;
}
export default function Table(props : TableProps<any>){
    const [page, setPage] = useState(1);
    const {actions = [], data = [], maxItems = 10, columns = [], loading = false, error, ...others} = props; 
    if(error) return <Group style={{color: "#9a9a9a", padding: '40px 0'}}>Falha ao carregar: {error}</Group>;
    
    return <>
        <div style={{padding: '10px 0'}}>
            {loading && <Loader />}
        </div>

        <Group>
            <Pagination
                style={{flex: 1}}
                total={((data.length ? data.length - 1 : 0) / maxItems) + 1}
                value={page}
                onChange={p => setPage(p)}
            />
            <Text>{(((page)-1) * maxItems) + 1} - {data.length < (page) * maxItems ? data.length : (page) * maxItems} de {data.length}</Text>
        </Group>

        <ScrollArea miw={100} mih={500}>
            <MantineTable
                {...others}
                verticalSpacing="xs"
                striped 
                highlightOnHover
            >
                <thead>
                    <tr>
                        {columns.map(column=> <th key={column.key} style={column.style}>{column.title}</th>)}
                        {actions.length > 0 && <th style={{width: 50}}></th>}
                    </tr>
                </thead>
                <tbody>
                    {data
                    .slice(maxItems*(page-1), maxItems*page)
                    .map((item, index) => <tr key={`${index}`} style={{backgroundColor: 'white'}}>
                        {columns.map(column => <td style={column.style}>{column.render ? column.render(item) : item[column.key]}</td>)}
                        {actions.length > 0 && <td><ActionsRender
                            actions={actions}
                            item={item}
                            index={index}
                        /></td>}
                    </tr>
                    )}
                </tbody>
            </MantineTable>
        </ScrollArea>
    </>
}